import { getAssetDisplayName } from './assetDisplayNames';

export const CURRENCY_DISPLAY_ORDER = [
  'USD', 'EUR', 'GBP', 'CHF', 'CAD', 'AUD', 'AED', 'SAR', 'KWD', 'QAR',
  'JPY', 'CNY', 'RUB', 'DKK', 'SEK', 'NOK', 'AZN', 'PLN', 'BGN'
];
export const GOLD_DISPLAY_ORDER = [
  'GRAM', 'GRAM_HAS', 'CEYREK', 'YARIM', 'TAM', 'XAU_CUM', 'ATA',
  'BILEZIK_22', 'AYAR_14', 'AYAR_18', 'GREMSE'
];
export const METAL_DISPLAY_ORDER = ['XAGTRYG', 'PLATIN', 'PALADYUM'];
export const MARKET_DISPLAY_ORDER = ['XU100', 'BTC', 'ETH', 'BRENT'];

const LEGACY_SYMBOLS = {
  GRA: 'GRAM', XAUTRYG: 'GRAM', XAUTRYG_OLD: 'GRAM',
  HAS: 'GRAM_HAS', CEYREKALTIN: 'CEYREK', XAU_QTR: 'CEYREK', XAU_QTR_NEW: 'CEYREK',
  YARIMALTIN: 'YARIM', XAU_HALF: 'YARIM', XAU_HALF_NEW: 'YARIM',
  TAMALTIN: 'TAM', XAU_FULL: 'TAM', XAU_FULL_NEW: 'TAM',
  CUMHURIYETALTINI: 'XAU_CUM', ATAALTIN: 'ATA', ATA_ALTIN: 'ATA',
  '14AYARALTIN': 'AYAR_14', '14K': 'AYAR_14', '18AYARALTIN': 'AYAR_18', '18K': 'AYAR_18',
  YIA: 'BILEZIK_22', '22K': 'BILEZIK_22', GREMSEALTIN: 'GREMSE',
  GUMUS: 'XAGTRYG', GPL: 'PLATIN', PAL: 'PALADYUM'
};

const knownSymbols = new Set([
  ...CURRENCY_DISPLAY_ORDER, ...GOLD_DISPLAY_ORDER, ...METAL_DISPLAY_ORDER, ...MARKET_DISPLAY_ORDER
]);

export const canonicalAssetKey = asset => {
  const values = typeof asset === 'string' ? [asset] : [asset?.symbol, asset?.code, asset?.rawSymbol];
  for (const value of values) {
    const key = String(value || '').trim().toLocaleUpperCase('tr-TR');
    if (!key) continue;
    const normalized = key.endsWith('TRY=X') ? key.slice(0, -5) : (LEGACY_SYMBOLS[key] || key);
    if (knownSymbols.has(normalized)) return normalized;
  }
  return String(values.find(Boolean) || '').toLocaleUpperCase('tr-TR');
};

const ORDER = Object.fromEntries(
  [CURRENCY_DISPLAY_ORDER, GOLD_DISPLAY_ORDER, METAL_DISPLAY_ORDER, MARKET_DISPLAY_ORDER]
    .flatMap(group => group.map((symbol, index) => [symbol, (index + 1) * 10]))
);

export const getAssetOrder = asset => ORDER[canonicalAssetKey(asset)] ?? 9999;

const score = asset =>
  (asset?.isActive !== false ? 100 : 0) +
  (asset?.isStale !== true ? 20 : 0) +
  (asset?.source === 'TRUNCGIL' ? 10 : 0) +
  (Number(asset?.buyPrice) > 0 || Number(asset?.price) > 0 ? 5 : 0) +
  (asset?.code === canonicalAssetKey(asset) ? 1000 : 0);

export const dedupeAndSortAssets = assets => {
  const bySymbol = new Map();
  for (const asset of assets || []) {
    if (asset?.isActive === false) continue;
    const key = canonicalAssetKey(asset);
    const current = bySymbol.get(key);
    const assetTime = new Date(asset?.fetchedAt || asset?.updatedAt || 0).getTime() || 0;
    const currentTime = new Date(current?.fetchedAt || current?.updatedAt || 0).getTime() || 0;
    if (!current || score(asset) > score(current) || (score(asset) === score(current) && assetTime > currentTime)) {
      bySymbol.set(key, { ...asset, code: key, symbol: key });
    }
  }
  return [...bySymbol.values()].sort((a, b) =>
    getAssetOrder(a) - getAssetOrder(b) || getAssetDisplayName(a).localeCompare(getAssetDisplayName(b), 'tr')
  );
};
